<template>
  <div v-if="!hidePages" class="padding-right-20 flex-1 padding-y-10 flex-between">
    <div class="flex-1 padding-right-10">
      <slot name="statistics"></slot>
    </div>
    <el-pagination
      v-if="asyncPage.total > 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      v-bind="syncPage"
      :total="asyncPage.total"
      :page-size.sync="asyncPage.pageSize"
      :current-page.sync="asyncPage.current"
    />
  </div>
</template>
<script >
import { reactive, computed, onMounted, nextTick } from '@vue/composition-api';
import { usePagination } from '../../hooks';
const __sfc_main = {};
__sfc_main.props = {
  initPages: {
    type: Object,
    default: () => ({})
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const pages = computed(() => props.initPages.pages);
  const hidePages = computed(() => typeof pages.value === 'boolean' && !pages.value);
  const {
    syncPage,
    asyncPage,
    setPagination
  } = usePagination(pages);
  const handleCurrentChange = val => {
    setPagination({
      current: val
    });
    props.initPages.onChange(reactive({
      type: 'currentChange',
      ...syncPage.value,
      ...asyncPage.value,
      current: val
    }));
  };
  const handleSizeChange = val => {
    setPagination({
      pageSize: val,
      current: 1
    });
    props.initPages.onChange(reactive({
      type: 'sizeChange',
      ...syncPage.value,
      ...asyncPage.value,
      pageSize: val
    }));
  };
  onMounted(() => {
    nextTick(() => {
      props.initPages.onChange({
        ...syncPage.value,
        ...asyncPage.value,
        type: 'init'
      });
    });
  });
  return {
    hidePages,
    syncPage,
    asyncPage,
    handleCurrentChange,
    handleSizeChange
  };
};
export default __sfc_main;
</script>
<style scoped lang="scss">
  .flex-end {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
</style>
